<div style="text-align: center; padding-bottom: 20px; padding-top: 20px">
  <h3>Finito!</h3>
  <h4>Stai per essere reindirizzato.</h4>
  <p style="font-weight: bold; padding-bottom: 10px">Se non vuoi attendere, clicca il pulsante per tornare alla pagina iniziale.</p>
  <ng-container *ngIf="logged; else noLogged">
    <button mat-raised-button color="primary" type="button" routerLink="/landing">Home</button>
  </ng-container>
  <ng-template #noLogged>
    <button mat-raised-button color="primary" type="button" routerLink="/startup">Start</button>
  </ng-template>
</div>
